import React, { useRef } from "react";
import {
  motion,
  useMotionTemplate,
  useMotionValue,
  useSpring,
} from "framer-motion";
import { FiMousePointer } from "react-icons/fi";
import { DashBoardIcon } from "../icons";
import { Link } from "react-router-dom";

const HoverTiltComponent = (props) => {
  return (
      <TiltCard {...props} />
  );
};

const ROTATION_RANGE = 10;
const HALF_ROTATION_RANGE = ROTATION_RANGE / 2;

const TiltCard = ({
    name,
    count,
    Icon,
    href,
    iconClass,
    iconBgClass,
    state,
}) => {
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const xSpring = useSpring(x);
  const ySpring = useSpring(y);

  const transform = useMotionTemplate`rotateX(${xSpring}deg) rotateY(${ySpring}deg)`;

  const handleMouseMove = (e) => {
    if (!ref.current) return [0, 0];

    const rect = ref.current.getBoundingClientRect();

    const width = rect.width;
    const height = rect.height;

    const mouseX = (e.clientX - rect.left) * ROTATION_RANGE;
    const mouseY = (e.clientY - rect.top) * ROTATION_RANGE;

    const rX = (mouseY / height - HALF_ROTATION_RANGE) * -1;
    const rY = mouseX / width - HALF_ROTATION_RANGE;

    x.set(rX);
    y.set(rY);
  };

  const handleMouseLeave = () => {
    x.set(0);
    y.set(0);
  };
  return (
    <motion.div
      ref={ref}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{
        transformStyle: "preserve-3d",
        transform,
      }}
      className="relative h-24 w-36  sm:h-32 sm:w-48 xl:h-40 xl:w-60 "
    >
      <Link
        style={{
          transform: "translateZ(75px)",
          transformStyle: "preserve-3d",
        }}
        className="absolute no-underline text-black inset-0 md:inset-4 overflow-hidden flex rounded-xl bg-white  "
        to={href}
        state={state}
      >
       <div className="px-3 md:px-4  py-3 basis-24 md:basis-36 flex flex-col">
        <p className="h-[50%] text-[9px] sm:text-[10px] xl:text-[16px] font-medium ">{name}</p>
        <span className="flex justify-start sm:text-xl xl:text-2xl    font-bold ">{count}</span>

       </div>
       <div className=" grow   flex items-center justify-center">
        <div className={`aspect-square flex items-center justify-center  h-14 me-2 xl:h-20 rounded-full ${iconBgClass} `}>
            <Icon additionalClasses={`   ${iconClass}`}/>
        </div>
       </div>
       <div className="h-10 w-20 bg-primaryColor rotate-[120deg] hidden group-hover:block z-10 absolute bottom-0 -right-12 transition-all border">

      </div>
      </Link>
      
    </motion.div>
  );
};

export default HoverTiltComponent;